exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blink[data-v-ed18da84]{animation:blinker-data-v-ed18da84 1s linear infinite}@keyframes blinker-data-v-ed18da84{50%{opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed18da84","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Site/Issues.vue
// module id = 410
// module chunks = 0